export default __webpack_public_path__ + "static/media/qi.e91c4f46.png";